import { createContext } from "react";
import { LocationHandlerContextValue } from "./types";

/**
 * @context LocationHandlerContext
 *
 * React Context that exposes the state and actions for managing
 * Location entities (create, edit, fetch, validation, modal state).
 *
 * The value is provided by <HandlerLocationProvider /> and consumed
 * through the custom hook useHandlerContext().
 *
 * When undefined, it means the context is being used outside
 * of the provider — the hook will throw an explicit error.
 */
export const LocationHandlerContext = createContext<
  LocationHandlerContextValue | undefined
>(undefined);
